module.exports = __webpack_public_path__ + "static/media/copy_lightbox.197352fc.svg";